export enum BalanceSearchFilter {
    ALL = 'All',
    DOCUMENT = 'Document',
    EMAIL = 'Email',
    ID = 'Id',
    USER_SEGMENTATION = 'USER_SEGMENTATION',
}
